<script setup lang="ts">
import type { LocationQueryValueRaw } from '#vue-router'
import GoogleLogo from '@/assets/google-logo.svg?component'

interface Props {
  redirect?: string
}

const { redirect = '/u/moje-konto' } = defineProps<Props>()

const runtimeConfig = useRuntimeConfig()
const route = useRoute()
const cartStore = useCartStore()
const guestTokenCookie = useCookie('token')

const login = async () => {
  // Pass guest token through OAuth state parameter to preserve cart reference
  const state = guestTokenCookie.value || ''
  await navigateTo({
    path: 'https://accounts.google.com/o/oauth2/auth',
    query: {
      protocol: 'oauth2',
      response_type: 'code',
      client_id: runtimeConfig.public.googleClientID as LocationQueryValueRaw,
      redirect_uri: `${runtimeConfig.public.baseUrl}/u/logowanie`,
      scope: 'openid profile email',
      code_challenge_method: '',
      state
    }
  }, { external: true })
}
const token = useCookie('auth.token')
if (route.query.code && route.query.scope?.toString().includes('google')) {
  const response = await $fetch('/google-login', {
    method: 'POST',
    body: {
      code: route.query.code,
      guestToken: route.query.state // Guest token passed through OAuth state
    }
  })
  token.value = response
  // Refresh cart store to reflect merged cart contents
  await cartStore.init()
  await navigateTo(redirect)
}
</script>

<template>
  <button class="flex items-center h-[40px] bg-white border border-[#B0B6BA] rounded-[40px] text-14 text-[#575757] px-[15px]" @click="login()">
    <GoogleLogo />
    <span class="w-full">Użyj konta Google</span>
  </button>
</template>
